import {InjectionToken} from '@angular/core';

export const AUTHORIZATION_CONFIG_TOKEN = new InjectionToken<{ [key: string]: (string[]) }>('authorization-config');
